export default __webpack_public_path__ + "static/media/the-tech-push-to-esg-data-management.3640dc04.jpg";